// extracted by mini-css-extract-plugin
export default {"Img":"CartListCourse_Img__AhILX","txt":"CartListCourse_txt__+gHoJ","txt2":"CartListCourse_txt2__-yu7n","txt3":"CartListCourse_txt3__uzNYF"};